import React from "react";
import { Button } from "@mui/material";

const CustomButton = ({ children, disabled, onClick, cursor, outline = false, fontSize, borderWidth, height, ...props }) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      {...props}
      sx={{
        cursor: cursor && cursor,
        backgroundColor: outline ? "transparent" : "#FF7900",
        color: outline ? "#FF7900" : "#fff",
        border: outline ? "2px solid #FF7900" : "none",
        borderRadius: "4px",
        padding: "10px 20px",
        fontSize: fontSize ? fontSize : "18px",
        fontWeight: "bold",
        borderWidth: borderWidth,
        height: height,
        textTransform: "capitalize",
        width: "100%",
        "&:hover": {
          backgroundColor: outline ? "#FF790033" : "#e65500",
          color: outline ? "#FF7900" : "#fff",
        },
      }}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
